import { render, staticRenderFns } from "./Dialog.vue?vue&type=template&id=fbb061d4&scoped=true"
import script from "./Dialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./Dialog.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Dialog.vue?vue&type=style&index=0&id=fbb061d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb061d4",
  null
  
)

export default component.exports